import { render } from "./invitation.vue?vue&type=template&id=1dc777a6&scoped=true&ts=true"
import script from "./invitation.vue?vue&type=script&lang=ts"
export * from "./invitation.vue?vue&type=script&lang=ts"

import "./invitation.vue?vue&type=style&index=0&id=1dc777a6&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc777a6"]])

export default __exports__